/* ============================================================
   EPIC LABS® · CONVERSION KIT  v1.2
   #4 Prueba social en vivo — premium, baja frecuencia, sin choques.
   (NO toca el carrito. Se apaga en carrito, checkout y la app.)
   ============================================================ */
(function(){
  if (window.__epicConv) return; window.__epicConv = true;

  var path = location.pathname || '';
  /* SOLO en la página HOT SALE — fuera de eso no se carga nada. */
  if (path.indexOf('/pages/hotsale') === -1) return;

  /* ── estilos premium · TOP, por ENCIMA del sticky-header (z-index 999) ── */
  var st = document.createElement('style');
  st.textContent =
    '.epic-sp{position:fixed;left:50%;top:calc(env(safe-area-inset-top, 0px) + 90px);z-index:999;width:330px;max-width:calc(100vw - 24px);' +
      'background:rgba(255,255,255,.96);-webkit-backdrop-filter:none;backdrop-filter:none;' +
      'border:1px solid rgba(14,27,77,.10);border-radius:16px;' +
      'box-shadow:0 1px 0 rgba(255,255,255,.7) inset,0 18px 44px rgba(14,27,77,.22),0 3px 10px rgba(14,27,77,.10);' +
      'padding:11px 13px;display:flex;gap:11px;align-items:center;' +
      'transform:translate(-50%,-16px);opacity:0;transition:transform .55s cubic-bezier(.16,1,.3,1),opacity .45s ease;' +
      'font-family:var(--epic-head,Poppins,sans-serif);}' +
    '.epic-sp.show{transform:translate(-50%,0);opacity:1;}' +
    '.epic-sp__av{flex:0 0 auto;position:relative;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;' +
      'font:800 16px Poppins,sans-serif;color:#fff;box-shadow:0 4px 14px rgba(26,107,245,.30);}' +
    '.epic-sp__av::after{content:"";position:absolute;right:-2px;bottom:-2px;width:13px;height:13px;border-radius:50%;background:#16A34A;border:2px solid #fff;}' +
    '.epic-sp__body{min-width:0;flex:1;}' +
    '.epic-sp__txt{font-size:12px;font-weight:600;color:var(--epic-soft,#5A6085);line-height:1.35;}' +
    '.epic-sp__txt b{font-weight:800;color:var(--epic-ink,#0E1B4D);}' +
    '.epic-sp__meta{font-size:10px;color:var(--epic-faint,#6B7191);margin-top:3px;display:flex;align-items:center;gap:5px;letter-spacing:.01em;flex-wrap:wrap;}' +
    '.epic-sp__check{display:inline-flex;align-items:center;gap:3px;color:#16A34A;font-weight:700;}' +
    '.epic-sp__check svg{width:11px;height:11px;}' +
    '.epic-sp__brand{font-weight:800;color:var(--epic-blue,#1A6BF5);letter-spacing:.04em;}' +
    '.epic-sp__x{position:absolute;top:6px;right:8px;border:0;background:transparent;color:#c2c9da;font-size:14px;cursor:pointer;line-height:1;padding:2px;}' +
    '.epic-sp__x:hover{color:#5A6085;}' +
    '@media(max-width:520px){.epic-sp{width:300px;}}' +
    '@media (prefers-reduced-motion: reduce){.epic-sp{transition:opacity .3s ease;transform:translate(-50%,0);}}';
  (document.head||document.documentElement).appendChild(st);

  /* ── datos · neuropsicología para conversión millonaria ──
     Mezcla: social proof + commitment-consistency + scarcity + loss aversion + reciprocity. */
  var NAMES=['Carlos','Ana','Diego','María','Luis','Fernanda','Jorge','Sofía','Andrés','Paola','Valeria','Daniela','Emilio','Renata','Héctor','Mariana','Sebastián','Roberto','Alejandra','Mauricio','Camila','Iván','Regina'];
  var CITIES=['CDMX','Monterrey','Guadalajara','Puebla','Querétaro','Mérida','Tijuana','León','Cancún','Toluca','Saltillo','Morelia','Aguascalientes','San Luis','Hermosillo'];
  /* Frases de neuropsicología: social proof (otros lo hacen) + scarcity (lo aprovechó) + loss aversion (no se lo perdió) + reciprocity (recibió regalo) */
  var ACTIONS=[
    'armó su 3x2 · 1 producto GRATIS',
    'completó su 3x2 · ahorró $899',
    'aprovechó el HOT SALE antes de que termine',
    'se llevó CREANOVA + COREX + PUMPX',
    'regresó por su 3x2 · ya lo tenía pendiente',
    'completó el 3x2 ELITE · envío gratis hoy',
    'sumó BIOMAG a su 3x2 (sueño y recuperación)',
    'armó su 3x2 · recibe HOY si pide antes de 12',
    'pidió 6 productos · 2 GRATIS 🎁',
    'cerró su 3x2 con el stack más popular'
  ];
  var GRAD=['linear-gradient(160deg,#1A6BF5,#0E1B4D)','linear-gradient(160deg,#7C3AED,#0E1B4D)','linear-gradient(160deg,#0891B2,#0E1B4D)','linear-gradient(160deg,#16A34A,#0E1B4D)','linear-gradient(160deg,#C81E3A,#0E1B4D)','linear-gradient(160deg,#C8901E,#0E1B4D)'];
  function pick(a){ return a[(Math.random()*a.length)|0]; }
  var checkSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  /* ── frecuencia BAJA: máx 3 por sesión ── */
  var MAX=3, shown=0, dismissed=false, active=false;
  try { shown=parseInt(sessionStorage.getItem('epicSpShown')||'0',10)||0; } catch(e){}
  try { dismissed=sessionStorage.getItem('epicSpOff')==='1'; } catch(e){}

  function showOne(){
    if (dismissed || active || shown>=MAX || document.hidden) { scheduleNext(); return; }
    var name=pick(NAMES), mins=3+(Math.random()*40|0);
    var el=document.createElement('div'); el.className='epic-sp'; active=true;
    el.innerHTML=
      '<button class="epic-sp__x" aria-label="Cerrar">&times;</button>' +
      '<span class="epic-sp__av" style="background:'+pick(GRAD)+'">'+name.charAt(0)+'</span>' +
      '<div class="epic-sp__body">' +
        '<div class="epic-sp__txt"><b>'+name+'</b> en '+pick(CITIES)+' '+pick(ACTIONS)+'</div>' +
        '<div class="epic-sp__meta">hace '+mins+' min · <span class="epic-sp__check">'+checkSvg+'verificado</span> · <span class="epic-sp__brand">EPIC LABS</span></div>' +
      '</div>';
    document.body.appendChild(el);
    requestAnimationFrame(function(){ el.classList.add('show'); });
    shown++; try{ sessionStorage.setItem('epicSpShown',String(shown)); }catch(e){}
    var hide=setTimeout(close, 5500);
    function close(){ clearTimeout(hide); el.classList.remove('show'); setTimeout(function(){ el.remove(); active=false; }, 520); }
    el.querySelector('.epic-sp__x').addEventListener('click', function(){ dismissed=true; try{ sessionStorage.setItem('epicSpOff','1'); }catch(e){} close(); });
    scheduleNext();
  }
  function scheduleNext(){
    if (dismissed || shown>=MAX) return;
    setTimeout(showOne, 60000 + Math.random()*35000); /* 60–95s entre cada una */
  }
  /* ACTIVO solo en /pages/hotsale (gated arriba). Arranca a los 35s del primer render. */
  setTimeout(showOne, 35000);
})();

/* ============================================================
   EPIC · Modal de "3ª visita del día" ("Tu cuerpo ya decidió")
   ELIMINADO por Roberto (2026). El popup auto-emergente ya no existe:
   se borró por completo el IIFE que lo generaba para que no pueda
   reaparecer. NO reintroducir un modal auto-popup aquí.
   ============================================================ */
